import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto max-w-xl px-5 py-20" role="alert" data-testid="error-boundary">
        <h1 className="text-2xl font-semibold">Something went wrong on this page.</h1>
        <p className="cw-soft mt-2 text-sm">{String(this.state.error?.message || this.state.error)}</p>
        <button onClick={() => window.location.reload()} className="mt-6 h-11 rounded-full bg-primary px-6 text-sm font-medium text-white" data-testid="error-boundary-reload-button">
          Reload
        </button>
      </div>
    );
  }
}
